// Lazysizes
import 'lazysizes';

// aspnet-client-validation bootup

import { ValidationService } from 'aspnet-client-validation';

let v = new ValidationService();
v.bootstrap();

// Alpine bootup
import Alpine from "./alpine/imports.js";

Alpine();
